import { useParams } from 'react-router-dom';

import InterviewPlanner from '~/pages/customer/reports/report-details/InterviewPlanner';

function InterviewPlannerButton() {
  const referenceId = useParams().reportId;
  return <InterviewPlanner referenceId={referenceId ?? ''} />;
  // return (
  //   <>
  //     <OtherActionsButton
  //       label={intl.formatMessage({ defaultMessage: 'Interview Planner' })}
  //       onClick={() => {
  //         setIsPopoverOpen(true);
  //       }}
  //       startIcon={<ChatCircleIcon />}
  //     />
  //     <InterviewPlannerPopover
  //       isOpen={isPopoverOpen}
  //       onClose={() => setIsPopoverOpen(false)}
  //     />
  //   </>
  // );
}

export default InterviewPlannerButton;
